import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { faEye, faPrint } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ModalAnalisePagamentoComponent } from 'src/app/shared/modals/modal-analise-pagamento/modal-analise-pagamento.component';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
import { AnalisePagamentoPdfComponent } from 'src/app/shared/pdf/analise-pagamento-pdf/analise-pagamento-pdf.component';
@Component({
    selector: 'app-analise-pagamento',
    templateUrl: './analise-pagamento.component.html',
    styleUrls: ['./analise-pagamento.component.css']
})
export class AnalisePagamentoComponent implements OnInit{

    @ViewChild('modal') modal!: ElementRef;

    //Icones
    faEye = faEye;
    faPrint = faPrint;

    formData: FormGroup = new FormGroup({
        ano: new FormControl(null, [Validators.required]),
        mesInicial: new FormControl(null, [Validators.required]),
        mesFinal: new FormControl(null, [Validators.required]),
        initialDate: new FormControl(null),
        finalDate: new FormControl(null)
    });
    pesquisado: boolean = false;
    years: any = [];
    defaultMonths: any[] = [
        { description: "Janeiro", number: 1 }, { description: "Fevereiro", number: 2 }, { description: "Março", number: 3 },
        { description: "Abril", number: 4 }, { description: "Maio", number: 5 }, { description: "Junho", number: 6 },
        { description: "Julho", number: 7 }, { description: "Agosto", number: 8 }, { description: "Setembro", number: 9 },
        { description: "Outubro", number: 10 }, { description: "Novembro", number: 11 }, { description: "Dezembro", number: 12 }];
    thisYearMonths!: any[];
    initialMonths!: any[];
    finalMonths!: any[];
    aposentadoria: any;
    nextYear: number = moment().add(1, 'm').year();
    loading: boolean = false;
    error: boolean = false;
    paymentAnalyzeItems: Array<any> = [];    
    
    constructor(private socialSecurityService: SocialSecurityService, private formBuilder: FormBuilder, private modalService: NgbModal) {
        this.formData.get('mesInicial')?.disable();
        this.formData.get('mesFinal')?.disable();
        this.socialSecurityService.getBenefitGranted().subscribe((res: any) => {
            let currentYear = new Date().getFullYear();
            let today = new Date();
            if (today.getMonth() == 0 && today.getDate() < 15) {
                currentYear--;
            }
            let startYear = 2003;
            this.years = [];
            while (currentYear >= startYear) {
                this.years.push(currentYear--);
            }
            res.forEach((element: any) => {
                let aposentadoria = moment(element.startPayment.split('T')[0]);
                if (!this.aposentadoria || this.aposentadoria > aposentadoria)
                    this.aposentadoria = aposentadoria;
                let currentYear = new Date().getFullYear();
                let today = new Date();
                if (today.getMonth() == 0 && today.getDate() < 15) {
                    currentYear--;
                }
                let startYear = 2003;
                if (startYear < this.aposentadoria.year())
                    startYear = this.aposentadoria.year();
                this.years = [];
                while (currentYear >= startYear) {
                    this.years.push(currentYear--);
                }
            });
        });

    }

    getPayment(prop:any){
        this.loading = true;        
         this.socialSecurityService.getPaymentAnalyze({initialDate: prop.initialDate.format("YYYY-MM-DD"), finalDate: prop.finalDate.format("YYYY-MM-DD")}).subscribe({
             next: (res: any) => {
                 this.paymentAnalyzeItems = res;                       
                 if(res.length == 0){
                    this.getPayment({ initialDate: prop.initialDate.subtract(1, 'month'), finalDate: prop.finalDate.subtract(1, 'month')});                
                 }else{
                    this.visualizarDetalhes(res[0]);
                    this.loading = false;
                 }
             }})
    }

    onFocus(event: Event) {
        (event.target as HTMLElement).blur();
      }

    ngOnInit(): void {        
        
        let ano = new Date().getFullYear();
        let mes = new Date().getMonth();

        // let firstPresentMonth = moment([ano, mes - 1, 1]);
        // let secondPresentMonth = moment([ano, mes - 1, firstPresentMonth.daysInMonth()]);

        // let firstMonth = moment([ano, mes - 1, 1]);
        // let secondMonth = moment([ano, mes - 1, firstMonth.daysInMonth()]);

        //     let firstFilter = {
        //         initialDate: firstMonth.format("YYYY-MM-DD"),
        //         finalDate: secondMonth.format("YYYY-MM-DD")
        //    }

        let firstMonth = moment([ano, mes , 1]);
        let secondMonth = moment([ano, mes , firstMonth.daysInMonth()]);

        let filter = {
             initialDate: firstMonth.format("YYYY-MM-DD"),
             finalDate: secondMonth.format("YYYY-MM-DD")
        }

        this.getPayment({initialDate: firstMonth, finalDate: secondMonth});

    }
    


    anoChanged() {
        let today = new Date();
        this.thisYearMonths = this.defaultMonths;
        if (this.aposentadoria && this.formData.value.ano == this.aposentadoria.year()) {
            this.thisYearMonths = this.thisYearMonths.filter((a: any) => a.number > this.aposentadoria.month());
        }
        if (this.formData.value.ano == today.getFullYear()) {
            let currentMonth = today.getMonth() + 1;
            if (currentMonth == 12 && today.getDate() < 7 || currentMonth != 12 && today.getDate() < 15) {
                currentMonth--;
            }
            this.thisYearMonths = this.thisYearMonths.filter(a => a.number <= currentMonth);
        }
        this.initialMonths = this.thisYearMonths;
        this.finalMonths = this.thisYearMonths;
        this.formData.get('mesInicial')?.enable();
    }

    mesChanged() {
        this.formData.get('mesFinal')?.enable();
        this.finalMonths = this.thisYearMonths.filter((a: any) => a.number >= this.formData.value.mesInicial);
    }

    consultar() {
        this.pesquisado = true;
        this.loading = true;
        let date1 = moment([this.formData.value.ano, this.formData.value.mesInicial - 1, 1]);
        let date2 = moment([this.formData.value.ano, this.formData.value.mesFinal - 1, 1]);
        let date3 = moment([this.formData.value.ano, this.formData.value.mesFinal - 1, date2.daysInMonth()]);
        let filter = {
            initialDate: date1.format("YYYY-MM-DD"),
            finalDate: date3.format("YYYY-MM-DD")
        }
        this.socialSecurityService.getPaymentAnalyze(filter).subscribe((res: any) => {
            this.paymentAnalyzeItems = res;
            this.loading = false;
            this.error = false;
        }, error => {
            this.loading = false;
            this.error = true;
        })
    }

    imprimir(details:any){
        const modalRef = this.modalService.open(AnalisePagamentoPdfComponent, { windowClass: 'download-pdf', size:"lg", centered: true });
        modalRef.componentInstance.paymentAnalyze = details;        
    }


    visualizarDetalhes(details: any) {
        const modalRef = this.modalService.open(ModalAnalisePagamentoComponent, { windowClass: 'carteirinha-modal-size', centered: true });
        modalRef.componentInstance.paymentAnalyze = details;
    }
}

